export const drawerWidth = 240;
export const drawerAdminWidth = 240;
export const boiDepartmentId = "ba3184c1-652f-4632-8d4f-3a5bae4e9349";
export const notificationTime = 30 * 1000;
export const platformName = "Web";
export const cancelServiceId = "46d5284d-6420-4b37-9c76-7c811d0297e6";
export const statusReportServiceId = "34a2e116-81cd-02dd-3fa1-36adba602fd3";
export const changeServiceId = "8ffa53f1-4e96-4c09-a13e-abc924dbff01";
export const IMM_ID = "909c1a6e-3b64-4596-8c77-c64ed37f7a5c";
export const REQUEST_DOCUMENT_STEP = [
  {
    hearding: "STEP 1",
    title: "Select Files",
    description: "Browse file to upload",
    icon: "/assets/icons/step-file.png",
    activeColor: "#2dce98",
  },
  {
    hearding: "STEP 2",
    title: "User Profile",
    description: "Filed Your Information",
    icon: "/assets/icons/step-profile.png",
    activeColor: "#19b2ed",
  },
  {
    hearding: "STEP 3",
    title: "Upload",
    description: "Required Documents",
    icon: "/assets/icons/step-upload-file.png",
    activeColor: "#40b8d4",
  },
];

export const VISA_TYPE_ID = {
  SMART_T: "1ec46938-5bf4-2e83-2dd0-1c9fe7ce95d5",
  SMART_E: "62342ded-028f-7261-108a-e28d19f81b53",
  SMART_O: "7d6281d0-9c7f-0d46-7de3-30e3baaa3eb4",
  SMART_I: "c6374fd6-456e-705c-768b-a221d4681eaa",
  SMART_S: "debf69dc-8920-54f1-663c-684f34aa8866",
};

export const VISA_TYPE_NAME = {
  [VISA_TYPE_ID.SMART_T]: "Smart T",
  [VISA_TYPE_ID.SMART_E]: "Smart E",
  [VISA_TYPE_ID.SMART_O]: "Smart I",
  [VISA_TYPE_ID.SMART_I]: "Smart O",
  [VISA_TYPE_ID.SMART_S]: "Smart S",
};

export const SMART_S_CONDITION_TYPE = {
  "2Y": "I have established a startup company in Thailand. (2-year)",
  "1YA":
    "I have participated in an incubation, accelerator or similar program endorsed by a government agency. (1-year)",
  "1YB":
    "I have received joint venture funding from the public sector or endorsed by relevant government agencies. (1-year)",
  "6M": "I wish to set up a startup company in Thailand or engage in promotional activities for startups (6-months)",
};

export const EXTENDSION_SMART_S_CONDITION_TYPE = {
  "1YA":
    "I have participated in an incubation, accelerator or similar program endorsed by a government agency. (1-year)",
  "1YB":
    "I have received joint venture funding from the public sector or endorsed by relevant government agencies. (1-year)",
  "2Y": "I have established a startup company in Thailand. (2-year)",
  "6MA": "I will continue with my current project (6-months) ",
  "6MB": "I am initiating a new project (6-months) ",
};

export const STATUS_PROCESS = {
  StatusName: "statusProcessId",
  Draft: "D",
  ReviewingHealthInsurance: "RHI",
  Pending: "P",
  RequestAddDoc: "RAI",
  UploadAddDoc: "UAD",
  Rejected: "R",
  SentManager: "SM",
  Reassign: "RA",
  Processing: "PC",
  FinalReviewing: "FRV",
  Approved: "A",
  FinalApproved: "FA",
  FinalRejected: "FR",
  VisaIssuance: "VI",
  VisaReceived: "VR",
  Complete: "C",
};

export const RoleId = {
  Staff: "ef21ca3e-e387-41dd-8fb5-82acf1cc155e",
  Supervisor: "e80df4d8-d2aa-4308-8757-79375daf2192",
  Director: "cb926fdf-3061-4db3-9ddb-42e51cee1562",
};

export const RequestDocStatus = {
  Request: "R",
  Uploaded: "U",
  Canceled: "C",
};

export const NotificationType = {
  RequestDocuments: "RequestDocuments",
};

export const translateCode = {
  en: "en",
  th: "th",
};

export const M24_CONFIG_DOC = {
  COC: {
    // หอการค้า
    SMART_SERVICE_ID: "b4439328-8ff4-45d9-a061-e960e2dfd428",
    CONDITION_TYPE: "COC",
  },
  COCP: {
    // หอการค้าบุคคล
    SMART_SERVICE_ID: "b4439328-8ff4-45d9-a061-e960e2dfd428",
    CONDITION_TYPE: "COCP",
  },
  COM: {
    // บริษัทที่อยู่ระหว่างการส่งเสริม
    SMART_SERVICE_ID: "2be27d71-47b5-45c1-be6d-1f015ba01ce7",
    CONDITION_TYPE: "COM",
  },
  COMP: {
    // บริษัทที่อยู่ระหว่างการส่งเสริมบุคคล
    SMART_SERVICE_ID: "2be27d71-47b5-45c1-be6d-1f015ba01ce7",
    CONDITION_TYPE: "COMP",
  },
  INV: {
    // ศึกษาลู่ทาง
    SMART_SERVICE_ID: "7393ad4c-0c8a-4e9b-9774-f81178569ba6",
    CONDITION_TYPE: "INV",
  },
  INVP: {
    // ศึกษาลู่ทางบุคคล
    SMART_SERVICE_ID: "7393ad4c-0c8a-4e9b-9774-f81178569ba6",
    CONDITION_TYPE: "INVP",
  },
};

export const M24_CONFIG_COMPANY_TO_PERSON = {
  COC: "COCP",
  COM: "COMP",
  INV: "INVP",
};
